import { useState } from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

// import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import classes from './TabsContainer.module.css';

const TabsContainer = props => {
  const [valueTab, setValueTab] = useState(0);
  console.log('🚀 ~ UDCClasses ~ valueTab:', valueTab);
  const itemsMenu = [
    {
      name: 'Mis materias',
      icon: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/misMaterias.png',
      value: 0,
      iconSize: { width: 34, height: 30 }
    },
    {
      name: 'Materias archivadas',
      icon: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/materiasArchivadas.png',
      value: 6,
      iconSize: { width: 32, height: 30 }
    },
    {
      name: 'Servicios Escolares',
      icon: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/serviciosEscolares.png',
      value: 7,
      iconSize: { width: 22, height: 30 }
    },
    {
      name: 'Agergar Materias',
      icon: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/agregarMaterias.png',
      value: 98,
      iconSize: { width: 30, height: 30 }
    }
  ];

  const handleChange = newValue => () => {
    props.changeSection(newValue);
    setValueTab(newValue);
  };

  return (
    <Tabs
      TabIndicatorProps={{ style: { background: '#333549' } }}
      value={valueTab}
      scrollable
      scrollButtons="on"
      className={classes.tabsContainer}
      onChange={handleChange}
    >
      {itemsMenu.map(item => (
        <Tab
          key={item.name}
          className={`${classes.tabButton} ${
            valueTab === item.value && classes.tabButtonSelected
          }`}
          onClick={handleChange(item.value)}
          label={item.name}
          icon={
            <img
              style={item.iconSize}
              src={item.icon}
              alt={item.name}
            />
          }
          value={item.value}
        />
      ))}
    </Tabs>
  );
};

TabsContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeSection: PropTypes.func
};

export default TabsContainer;
